module.exports = __webpack_public_path__ + "img/kudasai.da8328e9.svg";